"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const factures_1 = require("./factures");
class Devis extends factures_1.default {
    init() {
        super.init();
        this.moduleName = "devis";
        this.defaultIdTypeDocument = 2;
    }
    ready() {
        super.ready();
        // supprimer les options superflues du menu
        let menu = this.$$("menuDocuments");
        if (this.defaultIdTypeDocument == 2) {
            menu.hideMenuItem("avoirButton");
        }
    }
}
exports.default = Devis;
